
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"minus"}},[_c('rect',{attrs:{"id":"Rectangle","x":"0","y":"0","width":"20","height":"20"}}),_c('path',{attrs:{"d":"M9.77749559,9.77048447 L0.255062463,9.77048447 C0.240578589,9.7691198 0.225998625,9.7691198 0.211514751,9.77048447 C0.0832441531,9.78251809 -0.010991221,9.89632845 0.0010341474,10.024687 C0.0130595158,10.1530456 0.126791866,10.2473456 0.255062463,10.235312 L9.77749559,10.235312 L10.2420045,10.235312 L19.7644376,10.235312 C19.8481969,10.2364974 19.9261057,10.1924606 19.968331,10.1200643 C20.0105563,10.047668 20.0105563,9.95812846 19.968331,9.88573213 C19.9261057,9.81333582 19.8481969,9.76929909 19.7644376,9.77048447 L10.2420045,9.77048447 L9.77749559,9.77048447 Z","id":"Path","fill":"currentColor","fill-rule":"nonzero"}})])])])
          )
        }
      }
    